import { APIResource } from 'services'
import { JSONApiResourceDecorator } from 'utils'

export const ProtectedJsonAPI = new APIResource('',{},{ decorators: [JSONApiResourceDecorator]})